import { c as _c } from "react/compiler-runtime";
import { Tabbar } from '@systemeio/components';
import type { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import type { SettingsTabInterface } from 'modules/funnels/funnel/utils/funnel-setting-tabs';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin } from 'tailwind-merge';
interface FunnelSettingsTabbarProps {
  activeTab: FunnelStepSettingTabsEnum | null;
  className?: string;
  onSelectTab: (tabType: FunnelStepSettingTabsEnum) => void;
  tabs: SettingsTabInterface[];
  tabsDisabled: boolean;
}
function FunnelSettingsTabbar(t0) {
  const $ = _c(14);
  const {
    activeTab,
    className,
    onSelectTab,
    tabs,
    tabsDisabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== onSelectTab) {
    t1 = value => onSelectTab(value as FunnelStepSettingTabsEnum);
    $[0] = onSelectTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t || $[3] !== tabs || $[4] !== tabsDisabled) {
    let t3;
    if ($[6] !== t || $[7] !== tabsDisabled) {
      t3 = tab => ({
        children: state => <><span aria-hidden={true} className={twJoin("transition-base shrink-0", state === "active" && "text-icon-accent", state === "disabled" && "text-icon-disabled", state === "inactive" && "text-icon-tertiary")}>{tab.iconRenderer()}</span>{t(tab.caption)}</>,
        disabled: tabsDisabled,
        overflowLabel: t(tab.caption),
        value: tab.type
      });
      $[6] = t;
      $[7] = tabsDisabled;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = tabs.map(t3);
    $[2] = t;
    $[3] = tabs;
    $[4] = tabsDisabled;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== activeTab || $[10] !== className || $[11] !== t1 || $[12] !== t2) {
    t3 = <Tabbar className={className} onValueChange={t1} tabs={t2} value={activeTab} />;
    $[9] = activeTab;
    $[10] = className;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
export { FunnelSettingsTabbar };